<template>
  <div>
    <b-button
      v-b-modal.cadastro-localizacao
      variant="primary"
      class="ml-1"
      @click="limparCampo"
    >
      <feather-icon
        icon="PlusIcon"
      />
      Nova Classificação
    </b-button>

    <b-modal
      v-if="tipo === 'acordo'"
      id="cadastro-localizacao"
      title="Cadastrar Classificação Acordo"
      ok-title="Cadastrar"
      cancel-title="Cancelar"
      @ok="cadastrarAcordo"
    >
      <b-form-group
        label="Nome Acordo"
      >
        <b-form-input
          v-model="cadAcordo.nome"
        />
      </b-form-group>
    </b-modal>

    <b-modal
      v-if="tipo === 'cliente'"
      id="cadastro-localizacao"
      title="Cadastrar Classificação Cliente"
      ok-title="Cadastrar"
      cancel-title="Cancelar"
      @ok="cadastrarLocalizacao"
    >
      <b-form-group
        label="Nome Cliente"
      >
        <b-form-input
          v-model="cad.nome"
        />
      </b-form-group>
    </b-modal>

    <b-card>
      <b-row
        align-h="center"
        class="d-flex w-100 mb-2"
      >
        <b-button
          :variant="tipo === 'acordo' ? 'primary':'link'"
          class="font-weight-bold flex-grow-1 "
          @click="tipoTabela('acordo')"
        >
          Acordo
        </b-button>
        <b-button
          :variant="tipo === 'cliente' ? 'primary':'link'"
          class="font-weight-bold flex-grow-1 "
          @click="tipoTabela('cliente')"
        >
          Cliente
        </b-button>
      </b-row>

      <b-tabs>

        <b-tab v-if="tipo === 'acordo'">
          <b-row>
            <b-col>
              <b-row align-h="between">
                <b-col cols="1">
                  <b-form-group>
                    <b-form-select
                      v-model="perPageAcordo"
                      :options="[10, 15, 20]"
                      size="sm"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="8"
                >
                  <b-form-group>
                    <b-form-input
                      v-model="filterAcordo"
                      placeholder="Pequisar Acordo"
                      type="search"
                      size="sm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

            </b-col>
            <b-col cols="12">
              <b-table
                responsive
                bordered
                striped
                hover
                :filter="filterAcordo"
                :fields="fieldsLocalizacaoAcordo"
                :items="itemsAcordo"
                :per-page="perPageAcordo"
                :current-page="currentPage"
                @row-clicked="rowClickedAcordo"
                @filtered="onFilteredAcordo"
              />
            </b-col>

            <b-col cols="12">
              <b-pagination
                v-model="currentPage"
                :per-page="perPageAcordo"
                :total-rows="totalRowsAcordo"
                align="center"
                size="sm"
              />
            </b-col>
          </b-row>
        </b-tab>

        <b-tab v-else>
          <b-row>
            <b-col>
              <b-row align-h="between">
                <b-col cols="1">
                  <b-form-group>
                    <b-form-select
                      v-model="perPage"
                      :options="[10, 15, 20]"
                      size="sm"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="8"
                >
                  <b-form-group>
                    <b-form-input
                      v-model="filter"
                      placeholder="Pequisar Cliente"
                      type="search"
                      size="sm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-table
                responsive
                bordered
                striped
                hover
                :filter="filter"
                :fields="fieldsLocalizacao"
                :items="itemsLocalizacao"
                :per-page="perPage"
                :current-page="currentPage"
                @row-clicked="rowClicked"
                @filtered="onFiltered"
              />
            </b-col>
            <b-col cols="12">
              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                size="sm"
              />
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal
      v-if="tipo === 'cliente'"
      id="editModal"
      ref="editModal"
      title="Detalhes da Localização Cliente"
      hide-footer
    >
      <b-row>
        <b-col
          class="mb-2"
          cols="12"
        >
          Nome:
          <b-form-input
            v-model="localizacao.nome"
            :disabled="editar"
          />
        </b-col>
        <b-col
          cols="12"
          class="mb-2"
        >
          Cor:
          <b-form-input
            v-model="localizacao.cor"
            :disabled="editar"
          />
        </b-col>
        <b-col>
          <b-form-checkbox
            v-model="localizacao.status"
            :disabled="editar"
            switch
          />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <b-button
            v-show="editar"
            variant="outline-primary"
            @click="edicao"
          >
            <feather-icon
              icon="EditIcon"
            />
            Editar
          </b-button>
        </b-col>
        <b-col>
          <b-button
            variant="outline-danger"
            @click="deleteLoc"
          >
            <feather-icon
              icon="TrashIcon"
            />
            Excluir
          </b-button>
        </b-col>
        <b-col>
          <b-button
            v-show="!editar"
            variant="outline-secondary"
            @click="$refs.editModal.hide()"
          >
            <feather-icon
              icon="EditIcon"
            />
            Cancelar
          </b-button>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            @click="saveLoc(localizacao.id)"
          >
            <feather-icon
              icon="EditIcon"
            />
            Salvar
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-else-if="tipo === 'acordo'"
      id="editModal"
      ref="editModal"
      title="Detalhes da Localização Acordo"
      hide-footer
    >
      <b-row>
        <b-col
          class="mb-2"
          cols="12"
        >
          Nome:
          <b-form-input
            v-model="localizacaoAcordo.nome"
            :disabled="editarAcordo"
          />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <b-button
            v-show="editarAcordo"
            variant="outline-primary"
            @click="edicaoAcordo"
          >
            <feather-icon
              icon="EditIcon"
            />
            Editar
          </b-button>
        </b-col>
        <b-col>
          <b-button
            variant="outline-danger"
            @click="deleteLocAcordo"
          >
            <feather-icon
              icon="TrashIcon"
            />
            Excluir
          </b-button>
        </b-col>
        <b-col>
          <b-button
            v-show="!editarAcordo"
            variant="outline-secondary"
            @click="$refs.editModal.hide()"
          >
            <feather-icon
              icon="EditIcon"
            />
            Cancelar
          </b-button>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            @click="saveAcordo(localizacaoAcordo.id)"
          >
            <feather-icon
              icon="EditIcon"
            />
            Salvar
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BTable,
  BPagination,
} from 'bootstrap-vue'
import axios from '@/../axios-auth'

export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      tipo: 'acordo',

      editar: true,
      filter: '',
      cad: { // o que passa no corpo da requisição post
        nome: null,
        status: true,
      },
      totalRows: 1,
      perPage: 10,
      currentPage: 1,
      fieldsLocalizacao: [
        {
          key: 'id', class: 'text-center',
        },
        {
          key: 'nome', class: 'text-center',
        },
      ],
      itemsLocalizacao: [],
      localizacao: [],
      idLocalizacao: null,
      // AREA DA TABELA ACORDO
      editarAcordo: false,
      filterAcordo: '',
      cadAcordo: {
        nome: null,
      },
      totalRowsAcordo: 1,
      perPageAcordo: 10,
      currentPageAcordo: 1,
      fieldsLocalizacaoAcordo: [
        {
          key: 'id', label: 'ID', class: 'text-center',
        },
        {
          key: 'nome', label: 'Nome Acordo', class: 'text-center',
        },
      ],
      itemsAcordo: [],
      localizacaoAcordo: [],
      idLocalizacaoAcordo: null,
    }
  },
  async created() {
    this.listLoc()
  },
  mounted() {
    this.listarAcordo()
    this.listLoc()
  },
  methods: {
    tipoTabela(tipo) {
      this.tipo = tipo
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFilteredAcordo(Items) {
      this.totalRowsAcordo = Items.length
      this.currentPage = 1
    },
    limparCampo() {
      this.cad = {
        nome: null,
        status: true,
      }
      this.cadAcordo = { nome: null }
    },
    edicao() {
      this.editar = false
    },
    edicaoAcordo() {
      this.editarAcordo = false
    },
    rowClickedAcordo(item) {
      this.idLocalizacaoAcordo = item.id
      this.getLocalizacaoAcordo(item.id)
    },
    rowClicked(item) {
      this.idLocalizacao = false
      this.getLocalizacao(item.id)
    },

    async listLoc() {
      this.totalRows = null
      this.itemsLocalizacao = []
      await axios.get('api/v1/status_localizacao', {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(async res => {
        await res.data.dados.dados.map(dt => {
          this.itemsLocalizacao.push({
            id: dt.id,
            nome: dt.nome,
          })
        })
        this.totalRows = this.itemsLocalizacao.length
      })
    },
    // FUNÇÃO PARA LISTAR ACORDO
    async listarAcordo() {
      this.totalRowsAcordo = null
      this.itemsAcordo = []
      await axios.get('api/v1/acordo/classificacao/index', {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(async res => {
        await res.data.dados.map(dt => {
          this.itemsAcordo.push({
            id: dt.id,
            nome: dt.nome,
          })
        })
        this.totalRowsAcordo = this.itemsAcordo.length
      })
    },

    async getLocalizacao(id) {
      this.localizacao = []
      await axios.get(`api/v1/status_localizacao/edit/${id}`, {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(async res => {
        this.localizacao = {
          id: res.data.dados.status_localizacao.id,
          nome: res.data.dados.status_localizacao.nome,
          cor: res.data.dados.status_localizacao.cor,
          status: res.data.dados.status_localizacao.status,
        }
      })
      this.editar = false
      this.$refs.editModal.show()
    },

    async getLocalizacaoAcordo(id) {
      this.localizacaoAcordo = []
      await axios.get(`api/v1/acordo/classificacao/${id}`, {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(async res => {
        this.localizacaoAcordo = {
          id: res.data.dados.id,
          nome: res.data.dados.nome,
          cor: res.data.dados.cor,
          status: res.data.dados.status,
        }
      })
      this.editarAcordo = false
      this.$refs.editModal.show()
      this.listarAcordo()
    },

    // FUNÇÃO PARA CADASTRAR UM ACORDO
    async cadastrarAcordo() {
      await axios.post('api/v1/acordo/classificacao', this.cadAcordo, {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(async res => {
        if (await res.data.dados) {
          this.listarAcordo()
          this.$refs.editModal.hide()
          this.$swal({
            icon: 'success',
            title: 'Cadastrado!',
            text: 'Localização cadastrada com sucesso!',
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      }).catch(async error => {
        this.$swal({
          title: 'Erro ao Cadastrar Localização !',
          text: error.response.data.mensagem,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },

    async cadastrarLocalizacao() {
      await axios.post('api/v1/status_localizacao/store', this.cad, {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(async res => {
        if (await res.data.dados) {
          this.listLoc()
          this.$refs.editModal.hide()
          this.$swal({
            icon: 'success',
            title: 'Cadastrado!',
            text: 'Localização cadastrada com sucesso!',
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      }).catch(async error => {
        this.$swal({
          title: 'Erro ao Cadastrar Localização !',
          text: error.response.data.mensagem,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },

    async deleteLoc() {
      this.$swal({
        title: 'Tem certeza?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim quero deletar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios.delete(`api/v1/status_localizacao/delete/${this.idLocalizacao}`, {
            headers: {
              Authorization: 'Bearer '.concat(localStorage.getItem('token')),
              accept: 'application/json',
            },
          }).then(() => {
            this.$swal({
              icon: 'success',
              title: 'Cadastrado!',
              text: 'Localização excluida com sucesso!',
              timer: 1500,
              showConfirmButton: false,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }).catch(error => {
            this.$swal({
              title: 'Erro ao Excluir Localização !',
              text: error.response.data.mensagem,
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          })
          this.$refs.editModal.hide()
          this.listLoc()
        }
      })
    },

    async deleteLocAcordo() {
      this.$swal({
        title: 'Tem certeza?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim,quero deletar o acordo !',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios.delete(`api/v1/acordo/classificacao/${this.idLocalizacaoAcordo}`, {
            headers: {
              Authorization: 'Bearer '.concat(localStorage.getItem('token')),
              accept: 'application/json',
            },
          }).then(() => {
            this.$swal({
              icon: 'success',
              title: 'Excluído!',
              text: 'Acordo excluido com sucesso!',
              timer: 1500,
              showConfirmButton: false,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.listarAcordo()
          }).catch(error => {
            this.$swal({
              title: 'Erro ao Excluir Localização !',
              text: error.response.data.mensagem,
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          })
          this.$refs.editModal.hide()
        }
      })
    },

    async saveLoc(id) {
      axios.put(`api/v1/status_localizacao/update/${id}`, this.cad, {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(() => {
        this.listLoc()
        this.$refs.editModal.hide()
        this.$swal({
          title: 'Sucesso!',
          icon: 'success',
          text: 'Localização alterada com sucesso!',
          timer: 1500,
          showConfirmButton: false,
        })
      }).catch(error => {
        this.$swal({
          title: 'Errro ao alterar localização!',
          text: error.response.data.mensagem,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },
    async saveAcordo(id) {
      if (this.localizacaoAcordo.nome) {
        const bodyNome = this.localizacaoAcordo.nome
        try {
          await axios.put(`api/v1/acordo/classificacao/${id}`, { nome: bodyNome }, {
            headers: {
              Authorization: 'Bearer '.concat(localStorage.getItem('token')),
              accept: 'application/json',
            },
          })
          this.listLoc()
          this.$refs.editModal.hide()
          this.$swal({
            title: 'Sucesso!',
            icon: 'success',
            text: 'Acordo alterado com sucesso!',
            timer: 1500,
            showConfirmButton: false,
          })
          this.listarAcordo()
        } catch (error) {
          this.$swal({
            title: 'Erro ao alterar localização!',
            text: error.response?.data?.mensagem || 'Erro desconhecido',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        }
      }
    },
  },
}

</script>
